<template>
    <div :class="{'is-selected': isOutcomeSelected({
            outright,
            market,
            outcome,
        }) && details == false,
        'is-blocked': (outright.status == 'active' && outcome.status == 'block') && details == false}">
        <template v-if="details == false">
                <div class="odd-head">{{outcome.name | formatModifierName(null, market.specifiers)}}</div>
                <div class="odd-number" @click.stop="selectOutrightOutcome({
                    outright,
                    market,
                    outcome,
                })">
                    <div class="odd-change" :class="{'odd-up' : up, 'odd-down': down}"></div>
                    {{outcome.value | formatOdd}}
                </div>
            </template>

        <template v-else>
            <div class="sgame-odd-header">
            {{outcome.name | formatModifierName(null, market.specifiers)}}
            </div>
            <div class="sgame-odd-value"
            @click="selectOutrightOutcome({
                outright,
                market,
                outcome,
            })"
            :class="{'is-selected': isOutcomeSelected({
                outright,
                market,
                outcome,
            }), 'is-blocked': (outright.status == 'active' && outcome.status == 'block')}">
                <div class="odd-change" :class="{'odd-up' : up, 'odd-down': down}"></div>
                {{outcome.value | formatOdd}}
            </div>
        </template>
    </div>
</template>
<script>
import
{
    mapActions,
    mapGetters,
}
from 'vuex';

export default
{
    name: 'SingleOutrightOutcome',
    props: ['outright', 'market', 'outcome', 'details'],
    data()
    {
        return {
            up: false,
            down: false,
            deselected: false,
        };
    },
    methods:
    {
        ...mapActions([
            'selectOutrightOutcome',
        ]),
        isOutcomeSelected(param)
        {
            const {
                outright,
                outcome,
            } = param;

            if (this.betslipItemsMapping[
                `outrights_${outright.outrightsOfferId}_${outcome.outcomeHash}`
            ] != null)
            {
                return true;
            }

            return false;
        },
    },
    computed:
    {
        ...mapGetters(
            [
                'betslip',
                'betslipItemsMapping',
            ],
        ),
    },
    watch: {
        outcome(newVal, oldVal)
        {
            const me = this;
            const number = newVal.value;
            const oldNumber = oldVal.value;

            if (oldNumber === number)
            {
                return;
            }

            me.up = (oldNumber < number);
            me.down = (oldNumber > number);

            if (me.timeout !== false)
            {
                clearTimeout(me.timeout);
            }

            me.timeout = setTimeout(() =>
            {
                me.up = false;
                me.down = false;
            }, 1500);

            // TODO add subscription for this in betslip integration
            /* if (me.isOutcomeSelected)
            {
                const newOutcome = { ...me.outcome, value: Common.formatOdd(me.outcome.value) };
                me.betslip.updateItemOdd(newOutcome, me.match);
            } */
        },
    },
};
</script>
